/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { DateTimeTypes } from '@gh/common-shared';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { StlListItem } from '../../resources/stl.model';
import { ScheduledTaskStatus } from '@gh/builder-shared-data';

@Injectable()
export class StlGridDefinition extends LayoutBasedGridDefinition {

  buildColumnDefs(): Hash<ColDef> {
    return {
      status: {
        cellClass: ({data}: { data: StlListItem }) => ({
          [ScheduledTaskStatus.Success]: 'cell--positive',
          [ScheduledTaskStatus.Failed]: 'cell--negative',
          [ScheduledTaskStatus.PartialSuccess]: 'cell--unimportant',
        }[data.statusValue || '']),
      },
      startTime: buildDateTimeColumn(DateTimeTypes.Timestamp),
      endTime: buildDateTimeColumn(DateTimeTypes.Timestamp),
    };
  }

  buildGridOptions(): GridOptions {
    return { getRowNodeId: (data: StlListItem) => data.id };
  }
}
